@use "~theme/typography";

.button {
  border: none;
  cursor: pointer;
  padding: 0;
}

.inlineLink {
  @include typography.caption-link;
  border: none;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    border: none;
    color: var(--highlight-blue);
  }
}
